export default __webpack_public_path__ + "static/media/kitchen4-afterC-1024w.5e15ef53.avif";